import { render, staticRenderFns } from "./VideoFram.vue?vue&type=template&id=7e320a3e&scoped=true"
import script from "./VideoFram.vue?vue&type=script&lang=ts"
export * from "./VideoFram.vue?vue&type=script&lang=ts"
import style0 from "./VideoFram.vue?vue&type=style&index=0&id=7e320a3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e320a3e",
  null
  
)

export default component.exports